import { subscribeToRecordUpdates } from "../../../services/realtime/recordSseAdapter";

export const subscribeToProjectUpdates = ({
  projectId,
  userId,
  getToken,
  onProjectUpdated,
  onStatus,
  onError,
}) =>
  subscribeToRecordUpdates({
    resourceType: "project",
    subject: projectId,
    userId,
    getToken,
    onUpdated: onProjectUpdated,
    onStatus,
    onError,
  });
